import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const AttachmentContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.MuiCardContent-root': {
    paddingTop: '0px',
  }, 

  'button.hiddenButton': {
    color: 'transparent',
    background: 'transparent',
  },

  'button.hiddenButton:hover': {
    color: 'transparent',
    background: 'transparent',
    cursor: 'unset',
  },

  'button.hiddenButton:focus': {
    color: 'transparent',
    background: 'transparent',
    cursor: 'unset',
  },

  'button.hiddenButton:active': {
    color: 'transparent',
    background: 'transparent',
    cursor: 'unset',
  },
})

export const AttachmentFormContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  marginTop:'1rem',
  
  'div.fileUploadContainer': {
    width:'95%',
    display:'flex',
    flexDirection:'column',
    marginBottom:'1rem'
  },

  '>div:last-child':{
    marginRight:'0 !important'
  },

  '.sectionLeft': {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    marginRight: '15px',
  },

  '.sectionRight': {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },

  '.fileInput':{
    width:'100%'
  },

  '@media only screen and (min-width: 600px)': {
    flexDirection: 'row',

    'div.fileUploadContainer': {
      width:'47%',
      marginRight:'1rem',
    },
  },

  '@media only screen and (min-width: 769px)': {
    flexDirection: 'row',

    'div.fileUploadContainer': {
      width:'31%',
      marginRight:'1rem',
    },
  },
})

export const FileCont = styled.div((props)=>({
  display:'flex',
  marginTop:'0.5rem',

  '>div:first-child':{
    flex:1
  },
  '>div:last-child':{
    flex:4
  },

  '.titleFile':{
    fontWeight:'normal',
    display:'flex',
    justifyContent:'flex-end'
  },

  '.fileItem':{
    fontWeight:'normal',
    display:'flex',
    flexDirection:'column',
    'button':{
      marginTop:'0.1rem'
    }
  },

  '.fileName':{
    display:'flex',
    justifyContent:'flex-start',
    wordBreak: 'break-all',
  },

  '.noFile':{
    fontStyle:'italic',
    marginLeft: '1rem'
  },

  '.button':{
    marginLeft:'1rem'
  }
}))

export const AttachmentInfoContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
})

export const AttachmentContainer2 = styled.div({
  display: 'flex',
})

export const Cont2 = styled.div(props => ({
  display:'flex',
  flex:1,
  flexDirection:'column',
}))

export const SContDetail = styled.div(props => ({
  display: 'flex',
  marginTop: props.sub ? '0' : '1rem',

  '&>div:first-child': {
    marginLeft: 0,
    flex: 1
  },

  '>div:first-child .toleft': {
    marginLeft: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },

  '&>div': {
    marginLeft: '1rem',
    flex: 1
  }
}))

export const AttachmentGroup = styled.div({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  marginTop: '15px',

  '&:first-child': {
    marginTop: '0px',
  },

  'div.attachmentLabel': {
    display: 'flex',
    fontWeight: 'bold',
    minWidth: '100px',
    height: '40px',
    alignItems: 'center',
  },

  'div.attachmentBy': {
    display: 'flex',
    minWidth: '150px',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginRight: '5px',

    span: {
      fontWeight: 'bold',
    },
  },
})

export const AttachmentContent = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',

  'div:first-child>div': {
    marginTop: '0px',
  },

  'div>div': {
    marginTop: '5px',
  }
})